import React from 'react';
import { Modal, ModalFooter } from 'reactstrap';
import './index.css';

const AcceptOrderConfirmModal = ({ isOpen, toggle, acceptOrder }) => {
  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      centered
      id="AcceptOrderConfirmModal"
    >
      <div className="bodyArea">
        Are you sure want to accept this product's booking?
      </div>
      <ModalFooter>
        <button className="customButton" onClick={toggle}>
          No
        </button>
        <button
          className="customButton customButton_blue"
          onClick={acceptOrder}
        >
          Yes
        </button>
      </ModalFooter>
    </Modal>
  );
};

export default AcceptOrderConfirmModal;
